export default __webpack_public_path__ + "static/security-hacker-7a852064b4a074c4719944bb694c8579.svg";